/* eslint-disable no-unused-vars */

// Gestion des appels ajax
const $get = url => {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();

    req.onload = () => {
      if (req.readyState === 4 && req.status === 200)
        resolve(JSON.parse(req.response));
      else {
        console.error(`Oups, ça march'te pas 😕 [${url}]`);
        reject();
      }
    };

    req.open('GET', url);
    req.send();
  });
};

// Toggle
const $toggle = (element, type) => {
  const el = element;
  const { display } = el.ownerDocument.defaultView.getComputedStyle(el, null);

  if (display !== 'none') el.style.display = 'none';
  else el.style.display = type;
};

// A11Y Swiper
const a11y = () => {
  // a11y items duplicate
  const tabindex = -1;
  document.querySelectorAll('li.swiper-slide-duplicate > a').forEach(el => {
    el.setAttribute('tabindex', tabindex);
  });
  document.querySelectorAll('.swiper-slide-duplicate').forEach(el => {
    el.setAttribute('aria-hidden', 'true');
    el.removeAttribute('data-swiper-slide-index');
  });
  // a11y items not:duplicate
  const tabIndex = 0;
  document
    .querySelectorAll('li.swiper-slide:not(.swiper-slide-duplicate) > a')
    .forEach(el => {
      el.setAttribute('tabindex', tabIndex);
    });
  document
    .querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
    .forEach(el => {
      el.setAttribute('aria-hidden', 'false');
      el.removeAttribute('data-swiper-slide-index');
    });
};
